import { render, staticRenderFns } from "./StockInvoiceReview.vue?vue&type=template&id=2a198035&scoped=true&"
import script from "./StockInvoiceReview.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceReview.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceReview.vue?vue&type=style&index=0&id=2a198035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a198035",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VOverlay,VProgressCircular,VSkeletonLoader})
